// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charges-container{
    padding: 2rem;
     font-family: Arial, sans-serif;
}

.charges-container h2 {
  font-weight: 500;
  font-size: 20px;
}
/* Center loader */
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; /* full viewport height */
  gap: 12px;
  color: #333;
  background-color: transparent;
  font-size: 14px;
}

/* Round spinning loader */
.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #0070d2; /* Maersk blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Disabled button styles for action buttons */
mc-button[disabled] {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  filter: grayscale(70%) !important;
}

mc-button[disabled]:hover {
  opacity: 0.5 !important;
}

/* Additional styling for disabled buttons in table cells */
.charges-container mc-table mc-button[disabled] {
  opacity: 0.4 !important;
  filter: grayscale(80%) !important;
}

/* Alternative approach using CSS custom properties */
mc-button[disabled] {
  --mc-button-color: #999 !important;
  --mc-button-background-color: #e0e0e0 !important;
  --mc-button-border-color: #ccc !important;
}

/* Target the specific button appearances when disabled */
mc-button[appearance="primary"][disabled] {
  --mc-button-background-color: #ccc !important;
  background-color: #ccc !important;
  border-color: #999 !important;
  color: #666 !important;
}

mc-button[appearance="error"][disabled] {
  --mc-button-background-color: #ccc !important;
  background-color: #ccc !important;
  border-color: #999 !important;
  color: #666 !important;
}

mc-button[appearance="secondary"][disabled] {
  --mc-button-background-color: #f5f5f5 !important;
  background-color: #f5f5f5 !important;
  border-color: #ccc !important;
  color: #999 !important;
}


.notice-summary-table td {
  vertical-align: top;
}

/* ── Duplicate FO Number indicator ───────────────────────────────────────── */
.fo-duplicate-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fo-duplicate-value {
  color: #dc2626;
  font-weight: 600;
}

.fo-duplicate-icon {
  display: inline-flex;
  align-items: center;
  cursor: default;
  opacity: 0.85;
  transition: opacity 0.15s ease;
}

.fo-duplicate-icon:hover {
  opacity: 1;
}

/* Let pointer events pass through mc-icon up to the parent span so title tooltip works */
.fo-duplicate-icon mc-icon {
  pointer-events: none;
}
/* ─────────────────────────────────────────────────────────────────────────── */

/* Tablet & below */
@media (max-width: 768px) {
  .notice-summary {
    margin: 0.5rem !important;
    padding: 0.75rem !important;
  }

  .notice-summary-table tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 8px;
    margin-bottom: 12px;
  }

  .notice-summary-table td {
    padding: 6px !important;
  }

  /* Label cells */
  .notice-summary-table td:nth-child(odd) {
    font-weight: 600;
    color: #333;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .notice-summary-table tr {
    grid-template-columns: 1fr;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
  }

  .notice-summary-table td {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0 !important;
  }

  .notice-summary-table td:nth-child(odd) {
    font-size: 0.85rem;
    color: #555;
  }

  .notice-summary-table td:nth-child(even) {
    text-align: right;
    font-size: 0.9rem;
    word-break: break-word;
  }
  .parent-heading {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Charges/Charges.css"],"names":[],"mappings":"AAAA;IACI,aAAa;KACZ,8BAA8B;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,yBAAyB;EACxC,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,gBAAgB;EAC/C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,qDAAqD;AACrD;EACE,kCAAkC;EAClC,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA,yDAAyD;AACzD;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,yFAAyF;AACzF;EACE,oBAAoB;AACtB;AACA,gFAAgF;;AAEhF,mBAAmB;AACnB;EACE;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".charges-container{\n    padding: 2rem;\n     font-family: Arial, sans-serif;\n}\n\n.charges-container h2 {\n  font-weight: 500;\n  font-size: 20px;\n}\n/* Center loader */\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh; /* full viewport height */\n  gap: 12px;\n  color: #333;\n  background-color: transparent;\n  font-size: 14px;\n}\n\n/* Round spinning loader */\n.loader {\n  border: 6px solid #f3f3f3; /* Light grey */\n  border-top: 6px solid #0070d2; /* Maersk blue */\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Disabled button styles for action buttons */\nmc-button[disabled] {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n  filter: grayscale(70%) !important;\n}\n\nmc-button[disabled]:hover {\n  opacity: 0.5 !important;\n}\n\n/* Additional styling for disabled buttons in table cells */\n.charges-container mc-table mc-button[disabled] {\n  opacity: 0.4 !important;\n  filter: grayscale(80%) !important;\n}\n\n/* Alternative approach using CSS custom properties */\nmc-button[disabled] {\n  --mc-button-color: #999 !important;\n  --mc-button-background-color: #e0e0e0 !important;\n  --mc-button-border-color: #ccc !important;\n}\n\n/* Target the specific button appearances when disabled */\nmc-button[appearance=\"primary\"][disabled] {\n  --mc-button-background-color: #ccc !important;\n  background-color: #ccc !important;\n  border-color: #999 !important;\n  color: #666 !important;\n}\n\nmc-button[appearance=\"error\"][disabled] {\n  --mc-button-background-color: #ccc !important;\n  background-color: #ccc !important;\n  border-color: #999 !important;\n  color: #666 !important;\n}\n\nmc-button[appearance=\"secondary\"][disabled] {\n  --mc-button-background-color: #f5f5f5 !important;\n  background-color: #f5f5f5 !important;\n  border-color: #ccc !important;\n  color: #999 !important;\n}\n\n\n.notice-summary-table td {\n  vertical-align: top;\n}\n\n/* ── Duplicate FO Number indicator ───────────────────────────────────────── */\n.fo-duplicate-wrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.fo-duplicate-value {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.fo-duplicate-icon {\n  display: inline-flex;\n  align-items: center;\n  cursor: default;\n  opacity: 0.85;\n  transition: opacity 0.15s ease;\n}\n\n.fo-duplicate-icon:hover {\n  opacity: 1;\n}\n\n/* Let pointer events pass through mc-icon up to the parent span so title tooltip works */\n.fo-duplicate-icon mc-icon {\n  pointer-events: none;\n}\n/* ─────────────────────────────────────────────────────────────────────────── */\n\n/* Tablet & below */\n@media (max-width: 768px) {\n  .notice-summary {\n    margin: 0.5rem !important;\n    padding: 0.75rem !important;\n  }\n\n  .notice-summary-table tr {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    row-gap: 8px;\n    margin-bottom: 12px;\n  }\n\n  .notice-summary-table td {\n    padding: 6px !important;\n  }\n\n  /* Label cells */\n  .notice-summary-table td:nth-child(odd) {\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n/* Mobile */\n@media (max-width: 480px) {\n  .notice-summary-table tr {\n    grid-template-columns: 1fr;\n    border-bottom: 1px solid #e0e0e0;\n    padding-bottom: 10px;\n  }\n\n  .notice-summary-table td {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 4px 0 !important;\n  }\n\n  .notice-summary-table td:nth-child(odd) {\n    font-size: 0.85rem;\n    color: #555;\n  }\n\n  .notice-summary-table td:nth-child(even) {\n    text-align: right;\n    font-size: 0.9rem;\n    word-break: break-word;\n  }\n  .parent-heading {\n    font-size: 1rem;\n    margin-bottom: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
